class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.form = this.input?.form;

    if (!this.input || !this.form) return;

    this.onInputDebounced = debounce(this.onChange.bind(this), 300);

    this.form.addEventListener('reset', this.onFormReset.bind(this));
    this.input.addEventListener('input', this.onInputDebounced);
  }

  toggleResetButton() {
    if (!this.resetButton || !this.input) return;

    const resetIsHidden = this.resetButton.classList.contains('hidden');

    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !this.querySelector('[aria-selected="true"] a') && !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();

    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);